import { LangLocale, LangOpt, LanguagesMap } from './common';

export default class Util {
  static formatDate(arg: Date) {
    const y = '' + arg.getFullYear();
    const m = ('0' + (arg.getMonth() + 1)).slice(-2);
    const d = ('0' + arg.getDate()).slice(-2);
    const h = ('0' + arg.getHours()).slice(-2);
    const M = ('0' + arg.getMinutes()).slice(-2);
    const s = ('0' + arg.getSeconds()).slice(-2);
    const str = y + m + d + h + M + s;
    return str;
  }

  static formatCurrentDate() {
    return this.formatDate(new Date());
  }

  // input string is like this "20180410125424"
  static formatStringToDate(arg: string) {
    if (arg == null) {
      return ''
    }

    return (
      arg.slice(0, 4) +
      '-' +
      arg.slice(4, 6) +
      '-' +
      arg.slice(6, 8) +
      ' ' +
      arg.slice(8, 10) +
      ':' +
      arg.slice(10, 12) +
      ':' +
      arg.slice(12, 14)
    );
  }

  // TODO: need more implementations
  static localeToLang(locale: string) {
    const ret = LanguagesMap.get(locale as LangLocale) ?? LangOpt.English;
    return ret;
  }

  // TODO: need more implementations
  static langToLocale(lang: LangOpt) {
    let ret = LangLocale.en;
    for (let [k, v] of LanguagesMap) {
      if (v === lang) {
        ret = k;
        break;
      }
    }
    return ret;
  }
}
